module.exports = __webpack_public_path__ + "img/email.82b59ddf.svg";